import { boronClient } from "../../../api";
import { AiAssistantTemplateFormValues } from "../../../components/features/AiAssistantTemplateForm/validationSchema";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useAiAssistantTemplatesCacheUpdater } from "../../SectionsSettingsAiAssistantTemplatesPage/useFetchAiAssistantTemplates";

export const useCreateAiAssistantTemplate = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  const { invalidateAiAssistantTemplates } =
    useAiAssistantTemplatesCacheUpdater();

  return useBoronMutation(
    async (params: AiAssistantTemplateFormValues) =>
      await boronClient.POST(
        "/api/v1/sections/{section_id}/ai_assistant_templates",
        {
          params: { path: { section_id: sectionId } },
          body: { ai_assistant_template: params },
        },
      ),
    {
      onSuccess: () => {
        invalidateAiAssistantTemplates(sectionId);
      },
    },
  );
};
